<ng-container *ngIf="activeStage === 'select'">
    <div class="mat-typology fullscreen-dialog">
        <div class="sticky-header">

            <h1 mat-dialog-title class="sticky-title mb-0 !font-bold">Select networks</h1>

            <div class="actions">

                <button mat-stroked-button color="primary" (click)="activeStage = 'ip'">
                    Add IP Named Location
                </button>

                <button mat-stroked-button color="primary" (click)="activeStage = 'country'">
                    Add Country Named Location
                </button>
            </div>
        </div>



        <div class="content">
            <table class="w-full text-sm border-collapse">
                <thead>
                    <tr class="border-b font-semibold text-left">
                        <th class="px-4 py-2">Select</th>
                        <th class="px-4 py-2">Name</th>
                        <th class="px-4 py-2">Location Type</th>
                        <th class="px-4 py-2">Trusted</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of locations" class="border-b hover:bg-gray-50 cursor-pointer"
                        (click)="item.checked = !item.checked">
                        <td class="px-4 py-2" (click)="$event.stopPropagation()">
                            <mat-checkbox [(ngModel)]="item.checked"></mat-checkbox>
                        </td>
                        <td class="px-4 py-2"> <a (click)="openUpdateLocation(item)">
                                {{ item.displayName }}
                            </a> </td>
                        <td class="px-4 py-2">

                            <ng-container *ngIf="item['@odata.type'] === '#microsoft.graph.countryNamedLocation'">
                                {{ item.countryLookupMethod === 'authenticatorAppGps'
                                ? 'Countries (GPS)'
                                : 'Countries (IP)' }}
                            </ng-container>

                            <ng-container *ngIf="item['@odata.type'] === '#microsoft.graph.ipNamedLocation'">
                                IP ranges
                            </ng-container>
                        </td>
                        <td class="px-4 py-2">
                            {{ item.isTrusted === true ? 'Yes' : item.isTrusted === false ? 'No' : '' }}
                        </td>
                    </tr>
                </tbody>
            </table>





            <div *ngIf="locations?.length === 0"
                class="flex justify-center items-center h-32 bg-gray-100 rounded-md border border-dashed border-gray-300">
                <div class="text-center">
                    <p class="text-gray-600 font-medium">
                        No named locations found
                    </p>
                </div>
            </div>
        </div>
        <mat-dialog-actions class="dialog-footer">
            <button (click)="save()" mat-raised-button color="primary">
                Save
            </button>

            <button mat-dialog-close mat-raised-button>
                Cancel
            </button>
        </mat-dialog-actions>

    </div>

    <!-- <mat-divider></mat-divider> -->

</ng-container>

<ng-container *ngIf="activeStage === 'country'">
    <div class="fullscreen-dialog">

        <app-create-country-named-location [itemToBeUpdated]="itemToBeUpdated" [tenantId]="tenantId"
            (close)="activeStage = 'select'; itemToBeUpdated = null"></app-create-country-named-location>
    </div>
</ng-container>

<ng-container *ngIf="activeStage === 'ip'">
    <div class="fullscreen-dialog">
        <app-create-ip-named-location [itemToBeUpdated]="itemToBeUpdated" [tenantId]="tenantId"
            (close)="activeStage = 'select'; itemToBeUpdated = null"></app-create-ip-named-location>

    </div>
</ng-container>
